import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  EventLogEntryList,
  EventLogFieldGroupList,
  EventLogSearchBody,
} from 'src/swagger-gen/web-secured/models';
import { BaseService } from '../services/base.service';
import { AuthService } from '../tinea-components/okta/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class EventsRepo extends BaseService {
  stationUrl = environment.apiUrl + '/stations/';
  readonly EVENTLOGS_LIMIT = '20';
  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    public authService: AuthService
  ) {
    super();
  }

  /**
   * Get Events List
   * @param id station uid
   * @param offset offset
   * @param limit limit
   * @param params params
   * @param body body
   * @returns Observable event list
   */
  getEvents(
    id: string,
    offset: number,
    limit: number,
    params: any[],
    body: EventLogSearchBody
  ): Observable<EventLogEntryList> {
    const eventslogUrl = this.stationUrl + id + '/eventslog/search';
    let requestString = this.pagination(offset, limit, this.EVENTLOGS_LIMIT);

    let queryParams = '';
    params.forEach((p: any) => {
      queryParams += '&' + p.key + '=' + p.value;
    });

    requestString += queryParams;

    const requestParams = new HttpParams({ fromString: requestString });

    const httpOptions = {
      headers: this.httpHeaders(),
      params: requestParams,
    };

    return this.http
      .post<EventLogEntryList>(eventslogUrl, body, httpOptions)
      .pipe(
        tap((events: EventLogEntryList) => {
          this.logger.log(`Got ${events.paging.totalItems} events.`); // DEBUG
        }),
        catchError(this.handleServerError)
      );
  }

  /**
   *
   * @param eUid the station uid
   * @param offset the offset
   * @param limit the limit
   * @param params query params
   * @param body EventLogSearchBody
   * @return Observable Events Log Field Group list
   */
  getEventsLogFieldGroup(
    eUid: string,
    offset: number,
    limit: number,
    params: any[],
    body: any
  ): Observable<EventLogFieldGroupList> {
    const eventslogUrl = this.stationUrl + eUid + '/eventslog/group';
    let requestString = this.pagination(offset, limit, '20');

    let queryParams = '';
    params.forEach((p: any) => {
      queryParams += '&' + p.key + '=' + p.value;
    });

    requestString += queryParams;

    const requestParams = new HttpParams({ fromString: requestString });

    const httpOptions = {
      headers: this.httpHeaders(),
      params: requestParams,
    };

    return this.http
      .post<EventLogFieldGroupList>(eventslogUrl, body, httpOptions)
      .pipe(
        tap((events: EventLogFieldGroupList) => {
          this.logger.log(`Got ${events.paging.totalItems} events.`); // DEBUG
        }),
        catchError(this.handleServerError)
      );
  }

  getEventsLogListGroupByField(
    eUid: string,
    offset: number,
    limit: number,
    params: any[],
    body: any
  ): Observable<EventLogEntryList> {
    const eventslogUrl = this.stationUrl + eUid + '/eventslog/group/search';
    let requestString = this.pagination(offset, limit, '20');

    let queryParams = '';
    params.forEach((p: any) => {
      queryParams += '&' + p.key + '=' + p.value;
    });

    requestString += queryParams;

    const requestParams = new HttpParams({ fromString: requestString });

    const httpOptions = {
      headers: this.httpHeaders(),
      params: requestParams,
    };

    return this.http
      .post<EventLogEntryList>(eventslogUrl, body, httpOptions)
      .pipe(
        tap((events: EventLogEntryList) => {
          this.logger.log(`Got ${events.paging.totalItems} events.`); // DEBUG
        }),
        catchError(this.handleServerError)
      );
  }

  exportHistoricalData(
    eUid: string, 
    params: any[], 
    body: EventLogSearchBody
    ): Observable<any> {

    const url = this.stationUrl + eUid + '/data/historical/event/export';
    let queryParams = '';
    params.forEach((p: any, index) => {
      if (index === 0) {
        queryParams += p.key + '=' + p.value;
      } else {
        queryParams += '&' + p.key + '=' + p.value;
      }
    });

    const requestParams = new HttpParams({ fromString: queryParams });

    return this.http
      .post<any>(url, body, {
        headers: this.httpHeaders(),
        responseType: 'blob' as 'json',
        observe: 'response',
        params: requestParams,
      })
      .pipe(
        tap((data) => {
          this.logger.trace(`Export historical data in service.`, data);
        }), // DEBUG
        catchError(this.handleServerError)
      );
  }
}
